module.exports = __webpack_public_path__ + "static/media/United_Way_of_Jamaica_logo_vector.c8b2b0b7.png";